// extracted by mini-css-extract-plugin
module.exports = {"deleteModal":"q4zim","checkbox":"JwWJs","okButton":"_7xetw","modalText":"_0+FmT","content":"GtOU-","dot":"sdqyK"};